import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  loadPopupDetailsRequest: ['caId'],
  loadPopupDetailsSuccess: ['popupDetails'],
  loadPopupDetailsFailure: ['error'],

  getTermsAgreementRequest: ['caId'],
  getTermsAgreementSuccess: ['termsAgreementDetails'],
  getTermsAgreementFailure: ['error'],

  getPolicyDetailsRequest: ['params'],
  getPolicyDetailsSuccess: ['policyDetails'],
  getPolicyDetailsFailure: ['error'],

  getIpAddressRequest: [''],
  getIpAddressSuccess: ['ipAddress'],
  getIpAddressFailure: ['error'],

  uploadTermsDataRequest: ['payload'],
  uploadTermsDataSuccess: ['termsData'],
  uploadTermsDataFailure: ['error'],
});

const termsAndConditionsActions = {
  Types,
  Creators,
};

export default termsAndConditionsActions;
